import React, { useState } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Collapse } from '@mantine/core'
import { Button } from '@ow/comps'
import banner404img from './assets/banner-500.png'
import code from './assets/code.png'

export const StyledBox = styled.div`
  margin: auto;
  ${tw`flex flex-col md:flex-col lg:flex-row items-center`}
  max-width: 1200px;
  .top {
    margin: auto;
    margin-bottom: 40px;
    width: 60%;
    ${tw`flex flex-col md:flex-col lg:mr-[60px] lg:flex-row items-center`}
  }
  .topImg {
    height: auto;
    ${tw`w-[150px] md:w-[250px]`}
  }
  .detail {
    width: 100%;
    padding-left: 20px;
    margin-top: 40px;
  }
  .error {
    margin-bottom: 16px;
    font-weight: 1000;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.9);
    text-align: center;
  }
  .text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 48px;
  }
  .bottom {
    margin: auto;
    padding: 10px;
    ${tw`flex flex-col items-center md:flex-row md:items-start lg:w-[500px]`}
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  span {
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0;
    text-align: left;
  }
  .link {
    color: var(--ow-color-primary-500);
    font-size: 14px;
  }
  .copy {
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.6);
    color: var(--ow-color-primary-500);
    border: 2px solid #dcdcdc;
    border-radius: 8px;
  }
  .shareCode {
    ${tw`w-[100px] md:w-[160px] lg:w-[270px]`}
  }
`

const GenericNotFound = ({
  error = {},
  needDetail = false,
  resetErrorBoundary,
}) => {
  const [opened, setOpened] = useState(false)
  console.log('error', error)
  const render = () => {
    return (
      <StyledBox>
        <div className="top">
          <img className="topImg" src={banner404img} alt="page not found" />
          <div className="detail">
            <div className="error">发生了一些问题...</div>
            <div className="text">
              {error.title || '抱歉，页面发生了问题。请联系技术人员'}
            </div>
            <div className="flex justify-center">
              {needDetail && (
                <Button
                  style={{ fontSize: '14px', marginRight: '20px' }}
                  stroke
                  onClick={() => setOpened((o) => !o)}
                >
                  展开详情
                </Button>
              )}
              <Button
                style={{ fontSize: '14px' }}
                type="primary"
                onClick={resetErrorBoundary}
              >
                返回
              </Button>
            </div>
            {needDetail && (
              <Collapse in={opened}>
                <div className="h-[50px] overflow-auto mt-[10px] p-[6px] bg-white text-[12px]">
                  {error.message || ''}
                </div>
              </Collapse>
            )}
          </div>
        </div>
        <div className="bottom">
          <div className="left">
            <span>页面链接：</span>
            <span className="link">{window.location.href}</span>
            {/* <Button
              style={{ fontSize: '14px' }}
              type="primary"
              onClick={() => console.log('复制链接')}
            >
              复制链接
            </Button> */}
          </div>
          <div className="right">
            <img className="shareCode" src={code} alt="QR code " />
          </div>
        </div>
      </StyledBox>
    )
  }
  return render()
}

export default GenericNotFound
